import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useFetchData } from 'services/api/useFetchData';
import { AdditionalModule, createSubscriptionData, SubscriptionData, SubscriptionPackage } from '../../views/settings/billing/BillingTypes';
import PackageSelection from '../../views/settings/billing/subscription-wizard/PackageSelection';
import '../../style/scss/detailpage.scss';
import '../../style/scss/billing.scss';

const SubscriptionPlans: React.FC = () => {
    const { t } = useTranslation();
    const [subscriptionPackages, setSubscriptionPackages] = useState<SubscriptionPackage[] | null>(null);
    const [additionalModules, setAdditionalModules] = useState<AdditionalModule[] | null>(null);
    const [currentSubscription, setCurrentSubscription] = useState<SubscriptionData>(createSubscriptionData);
    const [updatedSubscription, setUpdatedSubscription] = useState<SubscriptionData>(createSubscriptionData);
    const [activeUsers, _] = useState<{ normal: string; light?: string }>({ normal: '1' });

    // Fetch the subscription packages
    const { response: fetchedSubscriptionPackages, loading: subscriptionPackagesLoading } = useFetchData({ 
        apiUrl: `get_subscription_package_list`
    });

    // Fetch the additional module options
    const { response: fetchedAdditionalModules } = useFetchData({ 
        apiUrl: `get_module_price_list`
    });

    // Set the subscription packages
    useEffect(() => {
        if (fetchedSubscriptionPackages) {
            const packages: SubscriptionPackage[] = fetchedSubscriptionPackages.results.map((pkg: any) => ({
                ...pkg,
                module_fields: pkg.module_fields ?? undefined,
            }));

            setSubscriptionPackages(packages);
        }
    }, [fetchedSubscriptionPackages]);

    // Set the additional module options
    useEffect(() => {
        if (fetchedAdditionalModules) {
            setAdditionalModules(fetchedAdditionalModules);
        }
    }, [fetchedAdditionalModules]);

    return (
        <div className='container-filled wizard subscription-wizard'>
            {subscriptionPackagesLoading === 'show-loader' ? (
                <div className='wizard-step'>
                    <div className='container-filled header-title'>
                        <h2>{t('billing.general.set_subscription_header')}</h2>
                    </div>
                    <div className="loader"></div>
                </div>
            ) : subscriptionPackagesLoading === 'success' && subscriptionPackages && (
                <div className='no-container wizard subscription-wizard'>
                    <PackageSelection
                        loading={subscriptionPackagesLoading}
                        packages={subscriptionPackages}
                        activeUsers={activeUsers}
                        currentSubscription={currentSubscription}
                        updatedSubscription={updatedSubscription}
                        setUpdatedSubscription={setUpdatedSubscription}
                    />
                </div>
            )}
        </div>
    );
};

export default SubscriptionPlans;